import {inject, Injectable, signal} from '@angular/core';
import {HttpClient, HttpContext, HttpErrorResponse} from '@angular/common/http';
import {catchError, of, tap} from 'rxjs';
import {MenuConfig, MenuItem} from './menu.model';
import {BaseOutput} from "../shared/models/fink.model";
import {MenuDefaults} from '../shared/utils/menu-groups.utils';
import {SILENT_ERROR} from './error.interceptor';

/** GET /backoffice/v1/uiConfig/code/{code}: the ui-config row travels in the `data` of the fink envelope. */
interface UiConfigResponse extends BaseOutput<{ config: MenuConfig }> {}

@Injectable({ providedIn: 'root' })
export class MenuService {
  private http = inject(HttpClient);

  readonly items         = signal<MenuItem[]>([]);
  readonly documentation = signal<MenuItem[]>([]);
  /** How the groups behave when they do not say (collapsible, initial state, opening of the current page's group). */
  readonly defaults      = signal<MenuDefaults | undefined>(undefined);
  readonly loadError = signal<string | null>(null);

  load() {
    // a new attempt (e.g. after a login) must not keep the failure of the previous one
    this.loadError.set(null);
    return this.http.get<UiConfigResponse>('/backoffice/v1/uiConfig/code/sidebar-menu', {
      // Suppress the interceptor toast — APP_INITIALIZER runs before DOM is ready,
      // so toasts would be lost. Error is stored in loadError and shown by LayoutComponent.
      context: new HttpContext().set(SILENT_ERROR, true),
    }).pipe(
      tap(res => {
        this.items.set(res.data?.config?.items ?? []);
        this.documentation.set(res.data?.config?.documentation ?? []);
        this.defaults.set(res.data?.config?.defaults);
      }),
      catchError((err: HttpErrorResponse) => {
        this.items.set([]);
        this.defaults.set(undefined);
        this.loadError.set(err.error?.error ?? "Impossibile caricare il menu dell'applicazione");
        return of(null);
      })
    );
  }
}
